<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong>{{ $t('router.listCustomers') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <a href="/dashboard/sale-orders/add-customer" target="_blank">
                  <CButton
                      class="mr-1"
                      size="sm"
                      color="secondary"
                  >{{$t('components.addCustomer')}}

                  </CButton>
                </a>
                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_with_header_title_height(body_id,header_id,'print_report_footer_customer_list',$t('router.listCustomers'),120,100)"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>

              </CCol>
            </CRow>

            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="3">
                <CSelect
                    :options="[{label:$i18n.t('all'),value:0},{label:$i18n.t('active'),value:1},{label:$i18n.t('deactivate'),value:2}]"
                    :value.sync="selected_status"
                />
              </CCol>
              <CCol col="1">
                <CButton @click="get_lists" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
            </CRow>
            <CRow>


              <CCol>
                <CSelect
                    :label="$t('components.province')"

                    :options="province_items"
                    :value.sync="selected_province"/>

              </CCol>
              <CCol>
                <CSelect
                    :label="$t('components.city')"

                    :options="city_items"
                    :value.sync="selected_city"/>

              </CCol>
              <CCol>
                <CSelect
                    :label="$t('town')"

                    :options="district_items"
                    :value.sync="selected_district"/>
              </CCol>
              <CCol>
                <CSelect
                    :label="$t('components.area')"

                    :options="area_items"
                    :value.sync="selected_area"/>

              </CCol>

              <CCol>
                <CSelect
                    :label="$t('route')"
                    :options="route_items"
                    :value.sync="selected_route"/>
              </CCol>
              <CCol>
                <CSelect
                    :label="$t('country')"
                    :value.sync="selected_country"
                    :options="country_items"
                />
              </CCol>

            </CRow>

           <div :id="body_id">

              <CDataTableFixed
                  :items="items_customer"
                  :fields="fields"
                  :column-filter="get_filter_table"
                  @row-clicked="table_row_clicked"
                  striped
                  border
                  :items-per-page="10"
                  :height="get_pagination? '300px' : ''"
                  hover
                  sorter
              >
                <template #row_id="{item,index}">

                  <td style="text-align: center">
                    <p>{{ index + 1 }}</p>
                  </td>

                </template>
                <template #userName="{item}">

                  <td>
                    <p>{{ item.userName }}</p>

                  </td>

                </template>


                <template #title="{item}">
                  <td>
                    <p v-if="item.title!=null">{{ item.title }}</p>
                  </td>
                </template>

                <template #routeName="{item}">
                  <td>
                    <p v-if="item.routeName!=null">{{ item.routeName }}</p>
                  </td>
                </template>
                <template #surName="{item}">
                  <td>
                    <p v-if="item.surName!=null">{{ item.surName }}</p>
                  </td>
                </template>
                <template #email="{item}">
                  <td>
                    <p v-if="item.email!=null">{{ item.email }}</p>
                  </td>
                </template>
                <template #jobProfile="{item}">
                  <td>
                    <p v-if="item.jobProfile!=null">{{ item.jobProfile }}</p>
                  </td>
                </template>
                <template #personCode="{item}">
                  <td>
                    <p class="text-center">{{ item.personCode }}</p>
                  </td>
                </template>
                <template #branch="{item}">
                  <td>
                    <p v-if="item.branch!=null">{{ item.branch }}</p>
                  </td>
                </template>

                <template #operation="{item}">
                  <td>
                    <CButton
                        class="m-1"
                        color="primary"
                        variant="outline"
                        square
                        :title="$t('buttons.edit')"

                        size="sm"
                        @click="goEditPerson(item)"
                    >
                      <CIcon name="cil-pencil"/>
                    </CButton>
                    <CButton class="m-1"
                             color="success"
                             variant="outline"
                             square
                             size="sm"
                             :title="$t('buttons.documents')"
                             @click="goToDocuments(item)"
                    >
                      <CIcon name="cil-list-rich"/>
                    </CButton>

                    <CButton class="m-1"
                             color="success"
                             variant="outline"
                             square
                             size="sm"
                             :title="$t('buttons.accountingReport')"
                             @click="goToAccountingReport(item)"
                    >
                      <CIcon name="cil-list"/>
                    </CButton>
                  </td>
                </template>


              </CDataTableFixed>
            </div>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="saleMethodModal"
        :no-close-on-backdrop="false"
        :centered="true"
        :title="$t('dialogs.editSaleMethod')"
        size="lg"
        color="dark"
    >
      <CSelect
          :options="method_list"
          :value.sync="selected_method"
          :label="$t('tables.saleMethod')"
      />
      <template #header>
        <h6 class="modal-title">{{ $t('dialogs.editSaleMethod') }}</h6>
        <CButtonClose @click="saleMethodModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="edit_person_sale_method(selected_method,selected_person)"
                 color="danger"
        >{{ $t("buttons.edit") }}
        </CButton>
        <CButton
            @click="saleMethodModal = false"
            color="success"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>
    <div v-show="false" :id="header_id"  style="margin-right: 50px;margin-left: 50px;margin-bottom: 30px">
      <CCol>
        <CRow style="justify-content:center">
          <strong style="font-size: large">{{get_bussiness_name()}}</strong>
        </CRow>

        <CRow style="justify-content:center">
          <strong>{{$t('router.listCustomers')}}</strong>
        </CRow>
        <CRow>
          <CCol >
            <p>{{$t('PreparedDate')}} {{get_date(get_today())}}</p>

          </CCol>
          <CCol >
            <!--                      <p>{{$t('PreparedDate')}} {{get_date(get_today())}}</p>-->
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <label v-if="selected_city!=0">{{city_items.filter(x=>x.cityId == selected_city)[0].cityName}} ,</label>
            <label v-if="selected_district!=0">{{district_items.filter(x=>x.id == selected_district)[0].title}} ,</label>
            <label v-if="selected_route!=0">{{route_items.filter(x=>x.id == selected_route)[0].title}}</label>
          </CCol>
        </CRow>
      </CCol>

    </div>
    <div v-show="false" id="print_report_footer_customer_list" >
      <CCardHeader>
        <CRow style="border: 1px solid #000">


          <CCol sm="4" md="4" style="text-align: start">
            <h5>{{ $t('docCreator') }} : {{ get_user_name() }}</h5>
          </CCol>
          <CCol sm="4" md="4" style="text-align: center">
            <h2 id="pageFooter" class="pageFooter"></h2>
          </CCol>
          <CCol sm="4" md="4" style="text-align: end">
            <h2>
            </h2>
          </CCol>
        </CRow>

      </CCardHeader>

    </div>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';



export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      header_id: "print_report_header_all_customer_list" + new Date().getTime() + this.$vnode.tag,
      body_id: "print_report_body_all_customer_list" + new Date().getTime() + this.$vnode.tag,
      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      selected_template: 0,
      description: '',
      saleMethodModal: false,
      method_list: [],
      selected_method: '',
      selected_person: 0,
      table_clicks: 0,
      table_clicks_timer: null,
      items_customer: [],
      fields: [
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
        // {key: 'personCode', label: this.$t('personalNo'), _style: 'width:10%'},
        {key: 'personCode', label: this.$t('tables.code'), _style: 'width:5%'},
        {key: 'userName', label: this.$t('name'), _style: 'width:10%'},
        {key: 'surName', label: this.$t('lastName'), _style: 'width:10%'},
        {key: 'mobileNo', label: this.$t('mobile'), _style: 'width:10%'},
        {key: 'cityTitle', label: this.$t('tables.city'), _style: 'width:10%'},
        {key: 'routeName', label: this.$t('route'), _style: 'width:10%'},
        // {key: 'operation', label: "", _style: 'width:10%'},
      ],
      route_items: [],
      selected_route: 0,

      area_items: [],
      selected_area: 0,

      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      district_items: [],
      selected_district: 0,

      country_items: [],
      selected_country: 0,

      details: [],

      collapseDuration: 0,
      selected_status: 0,

      status_form: 0
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_method_lists();
    this.get_country()
    this.get_routes()
    this.get_lists()
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    'selected_status': function () {
      this.get_lists();
    },
    'selected_province': function () {
      this.get_cities();
    },
    'selected_city': function () {
      this.get_districts();
    },
    'selected_district': function () {
      this.get_areas();
    },
    'selected_country': function () {
      this.get_provinces();
    },
  },
  methods: {
    get_country() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCountries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.country_items = [];

          self.country_items = self.sort_array(
              self.country_items, content_data.data,
              'id', 'title');

          if (self.$i18n.locale == 'fa') {
            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
          }
          if (self.$i18n.locale == 'en') {
            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.province_items = [];
          self.province_items.push({label:self.$t('dialogs.insertProvince'),value:0});

          self.province_items = self.sort_array(
              self.province_items, content_data.data,
              'id', 'provinceName');


          self.selected_province = self.province_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cities() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);

      axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.city_items = []
          self.city_items = self.sort_array(
              self.city_items, content_data.data,
              'cityId', 'cityName');

          self.selected_city = self.city_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_districts() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_city);

      axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.district_items = []
          self.district_items = self.sort_array(
              self.district_items, content_data.data,
              'id', 'title');

          self.selected_district = self.district_items[0].value;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_areas() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_district);

      axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.area_items = []
          self.area_items = self.sort_array(
              self.area_items, content_data.data,
              'id', 'areaName');

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.areaName, value: val.id}
          //
          //   self.area_items.push(obj);
          // });
          self.selected_area = self.area_items[0].value;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_routes() {
      var self = this;

      const formData = new FormData();

      axios.post('GetRoutesNew', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.route_items = [{label: self.$t('all'), value: 0}]
          self.route_items = self.sort_array(self.route_items, content_data.data, 'id', 'title')
          self.selected_route = self.route_items[0].value;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.table_clicks = 0

        this.goEditPerson(item)

      }

    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
    },
    get_method_lists() {
      var self = this;

      const formData = new FormData();


      axios.post('GetPriceMethodTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          content_data.data.forEach((val) => {
            var obj = {label: val.title, value: val.id}

            self.method_list.push(obj);


          });

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_person_sale_method(method, user_id) {
      this.saleMethodModal = false;
      let self = this;
      const formData = new FormData();
      let url;
      url = "EditPersonMethod";
      formData.append('MethodId', method);
      formData.append('PersonId', user_id);
      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.selected_method = '';
        self.selected_person = 0;

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    get_lists() {
      var self = this;


      const formData = new FormData();
      var url = "GetAllPersons";

      formData.append('IsVendor', false);
      formData.append('IsWorker', false);
      formData.append('IsCustomer', true);
      formData.append('IsActive', this.selected_status);
      formData.append('CountryId', this.selected_country);
      formData.append('CityId', this.selected_city);
      formData.append('ProvinceId', this.selected_province);
      formData.append('RegionId', this.selected_district);
      formData.append('AreaId', this.selected_area);
      formData.append('RouteId', this.selected_route);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
         content_data.data.forEach(function (val){
           val.surName = val.middelName+" - "+val.surName
         })
          self.items_customer = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          // self.items_customer = self.items_customer.concat(self.items_customer)
          // self.items_customer = self.items_customer.concat(self.items_customer)
          // self.items_customer = self.items_customer.concat(self.items_customer)
          // self.items_customer = self.items_customer.concat(self.items_customer)
          // self.items_customer = self.items_customer.concat(self.items_customer)

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_listsByArea() {
      var self = this;


      const formData = new FormData();

      var url = "GetUsers";

      formData.append("area_id", this.$route.params.area_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
// if(item.isCustomer){
            return {...item, row_id}

// }
          });

          self.items_customer = self.items_customer.filter(item => item.isCustomer);

          self.items_vendor = content_data.data.map((item, row_id) => {
            // console.log(item.isVendor);
            // if(item.isVendor){
            return {...item, row_id}

            // }
          });
          self.items_vendor = self.items_vendor.filter(item => item.isVendor);

          self.items_worker = content_data.data.map((item, row_id) => {
            // if(item.isCustomer){
            return {...item, row_id}

            // }
          });
          self.items_worker = self.items_worker.filter(item => item.isWorker);


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {
window.open('/dashboard/sale-orders/edit-customer/' + item.userId)
      // this.$router.push({path: '/dashboard/sale-orders/edit-customer/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/person-list/' + item.userId});

    },
    goToAccountingReport(item) {

      this.$router.push({path: '/dashboard/users/user-accounting-report/' + item.userId});

    },
    goToPorsant(item) {
      this.$router.push({path: '/dashboard/users/user-porsant/' + item.userId});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
